import PasswordList from "./components/PasswordList"
import Header from "./components/Header"
import PerfectScrollbar from "react-perfect-scrollbar"
import Search from "./components/Search"
import { useEffect, useState } from "react"
import Utils from "./libs/Utils"
import { useAuth } from "./gui/Login/AuthProvider"
import { useLogin } from "./gui/Login/LoginProvider"

const TIMEOUT = document.location.hostname=="localhost" ? 3600_000 : 60000
let timeout:any = null

export default function App(){
    const [scroll,setScroll] = useState<boolean>(false)
    const {isLoggedIn} = useAuth()
    const {logout} = useLogin()

    const clear = () => {
        window.removeEventListener("focus", clear)
        Utils.clipboard("")
    }
    const onLogout = () => {
        isLoggedIn && logout()
        if (!document.hasFocus()) {
            window.addEventListener("focus", clear)
        }
    }
    useEffect(() => {
        timeout = setTimeout(onLogout, TIMEOUT)
        return () => { clearTimeout(timeout) }
    }, [])

    const onScroll = (e:any) => {
        setScroll(e.scrollTop>0)
        onAlive()
    }
    const onAlive = () => {
        clearTimeout(timeout)
        timeout = setTimeout(onLogout, TIMEOUT)
    }
    if (isLoggedIn) {
        return <>
            <Header/>
            <Search className={scroll ? "scroll" : ""}/>
            <PerfectScrollbar onScrollY={onScroll} onMouseMove={onAlive}>
                <PasswordList/>
            </PerfectScrollbar>
        </>
    }
    return <></>
}
